exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ltrOverride {\n  direction: ltr !important;\n  unicode-bidi: bidi-override !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/less-loader!../node_modules/xo-ui-components/src/directionality/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!../node_modules/xo-ui-components/src/directionality/styles.less
// module chunks = 0